import { GLOBAL_EXPORT_BUTTON_ENABLED } from '../../../constants/user';

export const INITIAL_FILTERS_STATE = {
  user_id: '',
  url: '',
  sort_by: 'created_at',
  order: 'desc',
};

export const EXPORT_BUTTON_ENABLED = [
  ...GLOBAL_EXPORT_BUTTON_ENABLED,
];

export const DOMAINS_FIELDS = [
  {
    type: 'textField',
    label: 'User ID',
    name: 'user_id',
    placeholder: 'Search by user id',
    className: 'main',
  },
  {
    type: 'textField',
    label: 'URL',
    name: 'url',
    placeholder: 'Search by URL',
    className: 'main',
  },
];
